<template>
	<v-dialog
		v-model="showDialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">ゴム生地適合表作成</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<ValidationError :errors="errors" />
			<v-form ref="form" class="pa-2">
				<IncrementalSearchForm
					class="mt-4"
					:required="rubberSearchOption.required"
					:label="rubberSearchOption.label"
					:items="rubberSearchOption.items"
					:itemText="rubberSearchOption.itemText"
					:itemValue="rubberSearchOption.itemValue"
					:returnObject="rubberSearchOption.returnObject"
					:clearable="rubberSearchOption.clearable"
					:url="rubberSearchOption.url"
					:value.sync="rubberSearchOption.value"
					:initialItems="rubberSearchOption.initialItems"
					:targetName="rubberSearchOption.targetName"
				/>

				<IncrementalSearchForm
					class="mt-4"
					:required="customerCompanySearchOption.required"
					:label="customerCompanySearchOption.label"
					:items="customerCompanySearchOption.items"
					:itemText="customerCompanySearchOption.itemText"
					:itemValue="customerCompanySearchOption.itemValue"
					:returnObject="customerCompanySearchOption.returnObject"
					:clearable="customerCompanySearchOption.clearable"
					:url="customerCompanySearchOption.url"
					:value.sync="customerCompanySearchOption.value"
					:keywordKey="'name_cont'"
					:responseItemKey="'customer_companies'"
					:targetName="customerCompanySearchOption.targetName"
				/>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col sm="4" cols="0" />
					<v-col sm="4" cols="12">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="createRubberCustomerCompany" :disabled="!isValid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								登録する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import ValidationError from "../../shared/ValidationError.vue"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		rubber: {
			type: Object,
			required: false,
			default: () => {},
		},
	},
	components: {
		ValidationError,
		IncrementalSearchForm,
	},
	data() {
		return {
			errors: [],
			common,
			rubberSearchOption: {
				required: true,
				label: "ゴム生地名検索",
				items: [],
				itemText: "name",
				itemValue: "id",
				returnObject: true,
				clearable: true,
				value: null,
				url: "/erp/v1/incremental/search_rubbers",
				initialItems: [],
				targetName: "ゴム生地"
			},
			customerCompanySearchOption: {
				required: true,
				label: "顧客企業名検索",
				items: [],
				itemText: "name",
				itemValue: "id",
				returnObject: true,
				clearable: true,
				value: null,
				url: "/erp/v1/incremental/customer_companies",
				targetName: "顧客企業"
			},
		}
	},
	methods: {
		closeDialog() {
			this.showDialog = false
			this.$refs.form.reset()
		},
		fetchItems() {
			const params = {
				q: {
					name_cont: this.rubber.name,
				},
				page: 1,
			}
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			const headers = authenticate.setHeader()
			axios
				.get(this.rubberSearchOption.url, {
					headers,
					params,
					paramsSerializer,
				})
				.then((res) => {
					this.rubberSearchOption.initialItems = res.data.items
					this.rubberSearchOption.value = this.rubber
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createRubberCustomerCompany() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber/rubber_customer_companies/`
			axios
				.post(
					url,
					{
						rubber_customer_companies: {
							rubber_id: this.rubberSearchOption.value.id,
							customer_company_id: this.customerCompanySearchOption.value.id,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "登録しました。",
					})
					this.$emit("create", res.data.customer_company)
					this.closeDialog()
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				if (this.dialog && this.rubber) {
					this.fetchItems()
				}
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		isValid() {
			return (
				common.isPresence(this.rubberSearchOption.value) &&
				common.isPresence(this.customerCompanySearchOption.value)
			)
		},
	},
}
</script>
